import DashboardTemplate         from '../pages/Auth/Dashboard/DashboardTemplate';
import MinhaUtilizacaoTemplate   from '../pages/Auth/Contrato/MinhaUtilizacaoTemplate';
import UsuarioTemplate           from '../pages/Auth/Usuario/UsuarioTemplate';
import GrupoTemplate             from '../pages/Auth/Grupo/GrupoTemplate';
import PermissaoTemplate         from '../pages/Auth/Permissao/PermissaoTemplate';
import GrupoPermissionamentoPage from '../pages/Auth/GrupoPermissao/GrupoPermissionamentoPage';
import UsuarioGrupoTemplate      from '../pages/Auth/UsuarioGrupo/UsuarioGrupoTemplate';
import UsuarioSessaoTemplate     from '../pages/Auth/UsuarioSessao/UsuarioSessaoTemplate';
import UsuarioEquipamentoTemplate from '../pages/Auth/UsuarioEquipamento/UsuarioEquipamentoTemplate';
import UsuarioLogTemplate        from '../pages/Auth/UsuarioLog/UsuarioLogTemplate';
import UsuarioPinTemplate        from '../pages/Auth/UsuarioPin/UsuarioPinTemplate';
import AuditoriaTemplate         from '../pages/Auth/Auditoria/AuditoriaTemplate';
import PublicacaoTemplate        from '../pages/Auth/Publicacao/PublicacaoTemplate';
import PublicacaoLogTemplate     from '../pages/Auth/PublicacaoLog/PublicacaoLogTemplate';
import HomologacaoRouterboardTemplate from '../pages/Auth/HomologacaoRouterboard/HomologacaoRouterboardTemplate';
import HomologacaoIntegracaoTemplate from '../pages/Auth/HomologacaoIntegracao/HomologacaoIntegracaoTemplate';
import ConfiguracaoPage          from '../pages/Auth/Configuracao/ConfiguracaoPage';
import RouterboardTemplate       from '../pages/Auth/Routerboard/RouterboardTemplate';
import PlanoTemplate             from '../pages/Auth/Plano/PlanoTemplate';
import ModalidadeTemplate        from '../pages/Auth/Modalidade/ModalidadeTemplate';
import ContratoTemplate          from '../pages/Auth/Contrato/ContratoTemplate';
import ContratoUtilizacaoTemplate from '../pages/Auth/ContratoUtilizacao/ContratoUtilizacaoTemplate';
import VoucherTemplate           from '../pages/Auth/Voucher/VoucherTemplate';
import MidiaTemplate             from '../pages/Auth/Midia/MidiaTemplate';
import TermoUsoTemplate          from '../pages/Auth/TermoUso/TermoUsoTemplate';
import SmsEnvioTemplate          from '../pages/Auth/SmsEnvio/SmsEnvioTemplate';
import EmailEnvioTemplate        from '../pages/Auth/EmailEnvio/EmailEnvioTemplate';
import TarefaAgendadaTemplate    from '../pages/Auth/TarefaAgendada/TarefaAgendadaTemplate';
import TarefaAgendadaLogTemplate from '../pages/Auth/TarefaAgendadaLog/TarefaAgendadaLogTemplate';
import UsuarioTransacaoTemplate  from '../pages/Auth/UsuarioTransacao/UsuarioTransacaoTemplate';
import UsuarioEventoTemplate     from '../pages/Auth/UsuarioEvento/UsuarioEventoTemplate';
import PesquisaTemplate             from '../pages/Auth/Pesquisa/PesquisaTemplate';
import PesquisaExecucaoLogTemplate  from '../pages/Auth/PesquisaExecucaoLog/PesquisaExecucaoLogTemplate';
import PesquisaEnvioTemplate        from '../pages/Auth/PesquisaEnvio/PesquisaEnvioTemplate';
import PesquisaRespostaTemplate     from '../pages/Auth/PesquisaResposta/PesquisaRespostaTemplate';
import { UtilService } from 'hay-core-react';
import { withRouter } from 'hay-core-react';
import { codificarContexto, PARAM_CONTEXTO } from 'hay-core-react';
import { Usuario } from 'hay-core-react';
import Grupo                from '../models/Grupo';
import Permissao            from '../models/Permissao';
import GrupoPermissao       from '../models/GrupoPermissao';
import UsuarioGrupo         from '../models/UsuarioGrupo';
import UsuarioSessao        from '../models/UsuarioSessao';
import UsuarioEquipamento   from '../models/UsuarioEquipamento';
import UsuarioLog           from '../models/UsuarioLog';
import UsuarioPin           from '../models/UsuarioPin';
import { Auditoria } from 'hay-core-react';
import { Publicacao } from 'hay-core-react';
import PublicacaoLog          from '../models/PublicacaoLog';
import HomologacaoRouterboard from '../models/HomologacaoRouterboard';
import HomologacaoIntegracao from '../models/HomologacaoIntegracao';
import Configuracao         from '../models/Configuracao';
import Routerboard          from '../models/Routerboard';
import Plano                from '../models/Plano';
import Modalidade           from '../models/Modalidade';
import Contrato              from '../models/Contrato';
import ContratoUtilizacao    from '../models/ContratoUtilizacao';
import Voucher               from '../models/Voucher';
import Midia                from '../models/Midia';
import TermoUso              from '../models/TermoUso';
import SmsEnvio              from '../models/SmsEnvio';
import EmailEnvio            from '../models/EmailEnvio';
import TarefaAgendada        from '../models/TarefaAgendada';
import TarefaAgendadaLog     from '../models/TarefaAgendadaLog';
import UsuarioTransacao      from '../models/UsuarioTransacao';
import UsuarioEvento         from '../models/UsuarioEvento';
import Pesquisa              from '../models/Pesquisa';
import PesquisaExecucaoLog   from '../models/PesquisaExecucaoLog';
import PesquisaEnvio         from '../models/PesquisaEnvio';
import PesquisaResposta      from '../models/PesquisaResposta';

/**
 * Registro central de rotas autenticadas.
 *
 * Campos de cada entrada:
 *  rota          — path React Router
 *  icone         — classe PrimeIcons completa (ex: "pi pi-users")
 *  identidade    — chave i18n base (ex: "main.usuario")
 *  componente    — componente envolvido com withRouter
 *  camporelacao    — campo do registro usado como label em breadcrumbs (ex: "nome")
 *  relacoes      — array de { chave, campoPai }: chave = key desta tabela,
 *                  campoPai = campo na entidade relacionada que aponta para este pai
 *  sidebarOculto — oculta a rota do menu lateral (acessível só via Relações)
 */
export const grupos = {
    acesso: {
        label: 'main.acesso',
        icone: 'pi pi-lock',
    },
    plataforma: {
        label: 'main.plataforma',
        icone: 'pi pi-globe',
    },
    wifi: {
        label: 'main.wifi',
        icone: 'pi pi-wifi',
    },
};

const RotaService = {
    dashboard: {
        rota:         '/dashboard',
        icone:        'pi pi-home',
        identidade:   'main.dashboard',
        componente:   withRouter(DashboardTemplate),
        camporelacao: 'id',
    },
    minhautilizacao: {
        rota:              '/minhautilizacao',
        icone:             'pi pi-wallet',
        identidade:        'main.minhautilizacao',
        componente:        withRouter(MinhaUtilizacaoTemplate),
        camporelacao:      'id',
        // Reaproveita a permissão de PROCESSO contrato/meucontrato (não uma entidade própria) -
        // ver comentário de rotasPermitidas acima. Visível pra qualquer tenant com Contrato
        // vinculado, nunca pro tenant master (que não tem Contrato apontando pra si mesmo -
        // ContratoController.meucontrato retorna null nesse caso, tratado na própria tela).
        permissaoController: 'contrato',
        permissaoTipo:       'processo',
        permissaoState:      'main.contrato.meucontrato',
        // Acessada só pelo menu de contexto do usuário logado (AppToolbar), acima de
        // Configurações - não pelo menu lateral (feedback do card #91). A rota continua
        // registrada normalmente (React Router + rotasPermitidas), só não vira item de sidebar.
        sidebarOculto: true,
    },
    usuario: {
        rota:         '/usuario',
        icone:        'pi pi-users',
        identidade:   'main.usuario',
        componente:   withRouter(UsuarioTemplate),
        entidade:     Usuario,
        camporelacao: 'nome',
        relacoes:     [
            { chave: 'usuariogrupo', campoPai: 'usuario' },
            {
                chave:    'usuariosessao',
                campoPai: 'usuario',
                ativo:    (parentRecord) => parentRecord?.classificacao === 'main.usuario.classificacao.hotspot',
            },
            {
                chave:    'usuarioequipamento',
                campoPai: 'usuario',
                ativo:    (parentRecord) => parentRecord?.classificacao === 'main.usuario.classificacao.hotspot',
            },
            {
                chave:    'usuariolog',
                campoPai: 'usuario',
                ativo:    (parentRecord) => parentRecord?.classificacao === 'main.usuario.classificacao.hotspot',
            },
            {
                chave:    'usuariotransacao',
                campoPai: 'usuario',
                ativo:    (parentRecord) => parentRecord?.classificacao === 'main.usuario.classificacao.hotspot',
            },
            { chave: 'usuariopin', campoPai: 'usuario' },
            {
                chave:    'usuarioevento',
                campoPai: 'usuario',
                ativo:    (parentRecord) => parentRecord?.classificacao === 'main.usuario.classificacao.hotspot',
            },
            {
                chave:    'pesquisaenvio',
                campoPai: 'usuario',
                ativo:    (parentRecord) => parentRecord?.classificacao === 'main.usuario.classificacao.hotspot',
            },
        ],
        grupo:        'acesso',
    },
    grupo: {
        rota:         '/grupo',
        icone:        'pi pi-tags',
        identidade:   'main.grupo',
        componente:   withRouter(GrupoTemplate),
        entidade:     Grupo,
        camporelacao: 'nome',
        relacoes:     [{
            chave:    'grupopermissao',
            campoPai: 'grupo',
            ativo:    (parentRecord) => !parentRecord?.acessototal,
        }],
        grupo:        'acesso',
    },
    permissao: {
        rota:         '/permissao',
        icone:        'pi pi-lock',
        identidade:   'main.permissao',
        componente:   withRouter(PermissaoTemplate),
        entidade:     Permissao,
        camporelacao: 'state',
        grupo:        'acesso',
        requiresAcessoGeral: true,
    },
    grupopermissao: {
        rota:          '/grupo/grupopermissao',
        icone:         'pi pi-shield',
        identidade:    'main.grupopermissao',
        componente:    withRouter(GrupoPermissionamentoPage),
        entidade:      GrupoPermissao,
        camporelacao:  'id',
        sidebarOculto: true,
    },
    usuariogrupo: {
        rota:          '/usuario/usuariogrupo',
        icone:         'pi pi-link',
        identidade:    'main.usuariogrupo',
        componente:    withRouter(UsuarioGrupoTemplate),
        entidade:      UsuarioGrupo,
        camporelacao:  'id',
        sidebarOculto: true,
    },
    usuariosessao: {
        rota:          '/usuario/usuariosessao',
        icone:         'pi pi-clock',
        identidade:    'main.usuariosessao',
        componente:    withRouter(UsuarioSessaoTemplate),
        entidade:      UsuarioSessao,
        camporelacao:  'inicio',
        sidebarOculto: true,
    },
    usuarioequipamento: {
        rota:          '/usuario/usuarioequipamento',
        icone:         'pi pi-mobile',
        identidade:    'main.usuario.equipamento',
        componente:    withRouter(UsuarioEquipamentoTemplate),
        entidade:      UsuarioEquipamento,
        camporelacao:  'mac',
        sidebarOculto: true,
    },
    usuariolog: {
        rota:          '/usuario/usuariolog',
        icone:         'pi pi-list',
        identidade:    'main.usuariologacesso',
        componente:    withRouter(UsuarioLogTemplate),
        entidade:      UsuarioLog,
        camporelacao:  'datalog',
        sidebarOculto: true,
    },
    usuariopin: {
        rota:          '/usuario/usuariopin',
        icone:         'pi pi-key',
        identidade:    'main.usuariopin',
        componente:    withRouter(UsuarioPinTemplate),
        entidade:      UsuarioPin,
        camporelacao:  'tipo',
        sidebarOculto: true,
    },
    usuariotransacao: {
        rota:          '/usuario/usuariotransacao',
        icone:         'pi pi-credit-card',
        identidade:    'main.usuariotransacao',
        componente:    withRouter(UsuarioTransacaoTemplate),
        entidade:      UsuarioTransacao,
        camporelacao:  'idterceiros',
        sidebarOculto: true,
    },
    usuarioevento: {
        rota:          '/usuario/usuarioevento',
        icone:         'pi pi-bell',
        identidade:    'main.usuarioevento',
        componente:    withRouter(UsuarioEventoTemplate),
        entidade:      UsuarioEvento,
        camporelacao:  'descricao',
        sidebarOculto: true,
    },
    auditoria: {
        rota:         '/auditoria',
        icone:        'pi pi-hammer',
        identidade:   'main.auditoria',
        componente:   withRouter(AuditoriaTemplate),
        entidade:     Auditoria,
        camporelacao: 'id',
        grupo:        'acesso',
    },
    publicacao: {
        rota:              '/publicacao',
        icone:             'pi pi-globe',
        identidade:        'main.publicacao',
        componente:        withRouter(PublicacaoTemplate),
        entidade:          Publicacao,
        camporelacao:      'descricao',
        grupo:             'plataforma',
        requiresAcessoGeral: true,
        relacoes:          [{ chave: 'publicacaolog', campoPai: 'publicacao' }],
    },
    publicacaolog: {
        rota:          '/publicacao/publicacaolog',
        icone:         'pi pi-list',
        identidade:    'main.publicacaolog',
        componente:    withRouter(PublicacaoLogTemplate),
        entidade:      PublicacaoLog,
        camporelacao:  'endpoint',
        sidebarOculto: true,
        requiresAcessoGeral: true,
    },
    homologacaorouterboard: {
        rota:                '/homologacaorouterboard',
        icone:                'pi pi-verified',
        identidade:           'main.homologacaorouterboard',
        componente:           withRouter(HomologacaoRouterboardTemplate),
        entidade:             HomologacaoRouterboard,
        camporelacao:         'descricao',
        grupo:                'plataforma',
        requiresAcessoGeral:  true,
    },
    homologacaointegracao: {
        rota:                '/homologacaointegracao',
        icone:                'pi pi-link',
        identidade:           'main.homologacaointegracao',
        componente:           withRouter(HomologacaoIntegracaoTemplate),
        entidade:             HomologacaoIntegracao,
        camporelacao:         'descricao',
        grupo:                'plataforma',
        requiresAcessoGeral:  true,
    },
    modalidade: {
        rota:                '/modalidade',
        icone:               'pi pi-money-bill',
        identidade:          'main.modalidade',
        componente:          withRouter(ModalidadeTemplate),
        entidade:            Modalidade,
        camporelacao:        'nome',
        grupo:               'plataforma',
        requiresAcessoGeral: true,
    },
    contrato: {
        rota:                '/contrato',
        icone:               'pi pi-building',
        identidade:          'main.contrato',
        componente:          withRouter(ContratoTemplate),
        entidade:            Contrato,
        camporelacao:        'razaosocial',
        relacoes:            [{ chave: 'contratoutilizacao', campoPai: 'contrato' }],
        grupo:               'plataforma',
        requiresAcessoGeral: true,
    },
    contratoutilizacao: {
        rota:          '/contrato/contratoutilizacao',
        icone:         'pi pi-wallet',
        identidade:    'main.contratoutilizacao',
        componente:    withRouter(ContratoUtilizacaoTemplate),
        entidade:      ContratoUtilizacao,
        camporelacao:  'mesreferencia',
        sidebarOculto: true,
        requiresAcessoGeral: true,
    },
    configuracao: {
        rota:         '/configuracao',
        icone:        'pi pi-cog',
        identidade:   'main.configuracao',
        componente:   withRouter(ConfiguracaoPage),
        entidade:     Configuracao,
        camporelacao: 'descricao',
        grupo:        'plataforma',
    },
    routerboard: {
        rota:         '/routerboard',
        icone:        'pi pi-server',
        identidade:   'main.routerboard',
        componente:   withRouter(RouterboardTemplate),
        entidade:     Routerboard,
        camporelacao: 'descricao',
        grupo:        'wifi',
    },
    plano: {
        rota:         '/plano',
        icone:        'pi pi-wallet',
        identidade:   'main.plano',
        componente:   withRouter(PlanoTemplate),
        entidade:     Plano,
        camporelacao: 'descricao',
        grupo:        'wifi',
    },
    voucher: {
        rota:         '/voucher',
        icone:        'pi pi-ticket',
        identidade:   'main.voucher',
        componente:   withRouter(VoucherTemplate),
        entidade:     Voucher,
        camporelacao: 'codigo',
        grupo:        'wifi',
    },
    midia: {
        rota:         '/midia',
        icone:        'pi pi-images',
        identidade:   'main.midia',
        componente:   withRouter(MidiaTemplate),
        entidade:     Midia,
        camporelacao: 'nome',
        grupo:        'wifi',
    },
    termouso: {
        rota:         '/termouso',
        icone:        'pi pi-file-check',
        identidade:   'main.termouso',
        componente:   withRouter(TermoUsoTemplate),
        entidade:     TermoUso,
        camporelacao: 'versao',
        grupo:        'plataforma',
    },
    smsenvio: {
        rota:         '/smsenvio',
        icone:        'pi pi-send',
        identidade:   'main.smsenvio',
        componente:   withRouter(SmsEnvioTemplate),
        entidade:     SmsEnvio,
        camporelacao: 'destino',
        grupo:        'plataforma',
    },
    emailenvio: {
        rota:         '/emailenvio',
        icone:        'pi pi-envelope',
        identidade:   'main.emailenvio',
        componente:   withRouter(EmailEnvioTemplate),
        entidade:     EmailEnvio,
        camporelacao: 'destino',
        grupo:        'plataforma',
    },
    tarefaagendada: {
        rota:         '/tarefaagendada',
        icone:        'pi pi-history',
        identidade:   'main.tarefaagendada',
        componente:   withRouter(TarefaAgendadaTemplate),
        entidade:     TarefaAgendada,
        camporelacao: 'nome',
        relacoes:     [{ chave: 'tarefaagendadalog', campoPai: 'tarefaagendada' }],
        grupo:        'plataforma',
    },
    tarefaagendadalog: {
        rota:          '/tarefaagendada/tarefaagendadalog',
        icone:         'pi pi-list',
        identidade:    'main.tarefaagendadalog',
        componente:    withRouter(TarefaAgendadaLogTemplate),
        entidade:      TarefaAgendadaLog,
        camporelacao:  'datahorainicio',
        sidebarOculto: true,
    },
    pesquisa: {
        rota:         '/pesquisa',
        icone:        'pi pi-comment',
        identidade:   'main.pesquisa',
        componente:   withRouter(PesquisaTemplate),
        entidade:     Pesquisa,
        camporelacao: 'nome',
        relacoes:     [
            { chave: 'pesquisaexecucaolog', campoPai: 'pesquisa' },
            { chave: 'pesquisaenvio', campoPai: 'pesquisa' },
        ],
        grupo:        'plataforma',
    },
    pesquisaexecucaolog: {
        rota:          '/pesquisa/pesquisaexecucaolog',
        icone:         'pi pi-list',
        identidade:    'main.pesquisaexecucaolog',
        componente:    withRouter(PesquisaExecucaoLogTemplate),
        entidade:      PesquisaExecucaoLog,
        camporelacao:  'datahorainicio',
        sidebarOculto: true,
    },
    pesquisaenvio: {
        rota:          '/pesquisa/pesquisaenvio',
        icone:         'pi pi-send',
        identidade:    'main.pesquisaenvio',
        componente:    withRouter(PesquisaEnvioTemplate),
        entidade:      PesquisaEnvio,
        camporelacao:  'token',
        relacoes:      [{ chave: 'pesquisaresposta', campoPai: 'pesquisaenvio' }],
        sidebarOculto: true,
    },
    pesquisaresposta: {
        rota:          '/pesquisa/pesquisaresposta',
        icone:         'pi pi-star',
        identidade:    'main.pesquisaresposta',
        componente:    withRouter(PesquisaRespostaTemplate),
        entidade:      PesquisaResposta,
        camporelacao:  'nota',
        sidebarOculto: true,
    },
};

/**
 * Constrói os itens do menu "Relações" para uma entidade.
 *
 * @param {string}   controllerKey - Chave da entidade no RotaService (ex: 'usuario')
 * @param {object}   configuracao  - Objeto de configuração com permissoes e traducao
 * @param {function} navigate      - Função de navegação injetada por withRouter
 * @param {function} [getSelected] - Getter lazy que retorna o registro selecionado no momento do clique
 */
/**
 * Filtra RotaService retornando apenas as rotas em que o usuário tem
 * permissão de find (`identidade + '.find'` com `permitido: true`).
 *
 * @param {object} permissoes - Objeto de permissões retornado pelo login/autorizar
 * @returns {object} Subconjunto de RotaService com as rotas permitidas
 */
// Por padrão, uma rota fica visível conforme a permissão de ENTIDADE "<identidade>.mostrar" do
// seu próprio controller (mesmo nome da chave em RotaService) - cobre o caso comum de uma tela
// ligada 1:1 a um controller/model.
//
// Rotas que reaproveitam um PROCESSO de outro controller (ex.: menu de contexto que chama uma
// action customizada, não o CRUD padrão daquele controller) não se encaixam nisso: a chave em
// RotaService precisa ser própria (pra ter identidade/tradução/ícone dedicados), mas a permissão
// mora em outro controller e é do tipo "processo", não "entidade". Pra esses casos, a própria
// entrada declara `permissaoController`/`permissaoTipo`/`permissaoState` explicitamente,
// sobrepondo o comportamento padrão acima (ver "minhautilizacao", que reaproveita
// contrato/meucontrato).
export function rotasPermitidas(permissoes) {
    return Object.fromEntries(
        Object.entries(RotaService).filter(([controller, cfg]) => {
            if (cfg.requiresAcessoGeral && !permissoes?.permiteacessogeral) return false;
            const ctrl = permissoes?.[cfg.permissaoController || controller];
            if (!ctrl) return false;
            const bucket = cfg.permissaoTipo === 'processo' ? ctrl.processos : ctrl.entidade;
            const state = cfg.permissaoState || (cfg.identidade + '.mostrar');
            return bucket?.some(e => e.state === state && e.permitido);
        })
    );
}

export function buildRelacionados(controllerKey, permissoes, navigate, getSelected) {
    const cfg = RotaService[controllerKey];
    if (!cfg?.relacoes?.length) return [];
    const traduzir = (chave) => UtilService.traduzir(chave);
    const parentRecordAtual = getSelected?.() || null;

    return cfg.relacoes
        .filter(rel => {
            const chave = typeof rel === 'string' ? rel : rel.chave;
            return permissoes[chave]?.entidade?.some(e => e.permitido);
        })
        .map(rel => {
            const chave      = typeof rel === 'string' ? rel : rel.chave;
            const campoPai   = typeof rel === 'string' ? null : rel.campoPai;
            const ativo      = typeof rel === 'string' ? null : rel.ativo;
            const relCfg     = RotaService[chave];
            // Sem registro selecionado, o item não deve ficar desabilitado — clicar nesse caso
            // navega pro grid completo, sem filtro (ver comentário no command() abaixo). A
            // checagem de `ativo` (ex.: só habilitar pra usuário de classificação hotspot) só se
            // aplica quando HÁ um registro pai selecionado.
            const habilitado = !parentRecordAtual || typeof ativo !== 'function' || ativo(parentRecordAtual) !== false;

            return {
                label:    traduzir(relCfg.identidade + '.plural'),
                icon:     relCfg.icone,
                disabled: !habilitado,
                command: () => {
                    // Sempre manda o contexto do pai, com ou sem registro selecionado — sem esse
                    // contexto (Estado 1 do RelatedEntityGrid) o breadcrumb/botão "voltar" não
                    // aparecem, e esta tela é sempre uma relação, nunca acesso solto. Sem registro
                    // selecionado, parentId/parentLabel viajam null (Estado 2): RelatedEntityGrid já
                    // sabe não filtrar nesse caso (só filtra quando há parentId de verdade),
                    // mostrando o grid completo mas com breadcrumb/voltar disponíveis mesmo assim.
                    const parentRecord = getSelected?.() || null;
                    const parentLabel = parentRecord ? (parentRecord[cfg.camporelacao] ?? String(parentRecord.id)) : null;
                    const ctx = codificarContexto({
                        parentId:            parentRecord?.id ?? null,
                        parentLabel,
                        campoPai,
                        parentControllerKey: controllerKey,
                        parentRota:          cfg.rota,
                        parentIdentidade:    cfg.identidade,
                        parentIcone:         cfg.icone,
                        camporelacaoAtual:   relCfg.camporelacao,
                    });
                    navigate({
                        pathname: relCfg.rota,
                        search: ctx ? { [PARAM_CONTEXTO]: ctx } : {},
                    });
                },
            };
        });
}

export default RotaService;
